import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger
} from "../../../ui/common/select";
import { MAPPING_HEADER_COPY } from "../constants/mappingHeader.constants";

interface MappingProductSelectProps {
  productName?: string;
  options: DropdownOption[];
  selectedValue: string;
  onSelect: (value: string) => void;
}

/**
 * Product segment control. The trigger shows only the product name (the sales unit sits on its
 * own sub-line in MappingHeaderCard), so it renders a plain span rather than `SelectValue` --
 * `SelectValue` would echo the selected option's full "name - sales unit" label instead.
 */
export const MappingProductSelect = ({
  productName,
  options,
  selectedValue,
  onSelect
}: MappingProductSelectProps) => (
  <Select value={selectedValue} onValueChange={onSelect}>
    <SelectTrigger
      size="sm"
      aria-label={MAPPING_HEADER_COPY.productLabel}
      className="tw-w-full tw-border-0 tw-bg-transparent tw-p-0 tw-shadow-none focus-visible:tw-ring-0 tw-text-sm tw-font-semibold tw-text-primary [&_svg]:tw-text-primary [&_svg]:tw-opacity-60"
    >
      <span className="tw-truncate">
        {productName || MAPPING_HEADER_COPY.productPlaceholder}
      </span>
    </SelectTrigger>
    <SelectContent>
      {options.map(option => (
        <SelectItem key={option.key} value={String(option.value)}>
          {option.text}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
